import { DESKTOP } from "@/themes/device";
import styled from "@emotion/styled";
import {
  grayScale,
  mBody1,
  mBody2,
  mHeader0,
  mHeader1,
  mTitle1,
  swc,
  wBody1,
  wBody2,
  wHeader2,
  wTitle1,
} from "@teamsparta/design-system";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 328px;

  ${DESKTOP} {
    justify-content: center;
    align-items: center;
    width: initial;
    @media (max-width: 1152px) {
      width: 950px;
    }
  }
`;

export const Title = styled.h3`
  ${mHeader1}
  color: ${grayScale.gray100};
  margin-bottom: 50px;

  ${DESKTOP} {
    ${wHeader2}
    color: ${grayScale.gray100};
    text-align: center;
  }
`;

export const Benefits = styled.section`
  display: flex;
  flex-direction: column;
  gap: 50px;

  ${DESKTOP} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: initial;
    max-width: 1152px;
  }
`;

export const BenefitNumber = styled.small`
  display: block;
  ${mBody1}
  color: ${swc.blue};
  font-weight: 700;
  margin-bottom: 10px;

  ${DESKTOP} {
    ${wBody1}
    color: ${swc.blue};
    font-weight: 700;
  }
`;

export const BenefitTitle = styled.h4`
  ${mTitle1}
  color: ${grayScale.gray90};
  font-weight: 700;
  margin-bottom: 24px;

  ${DESKTOP} {
    ${wTitle1}
    color: ${grayScale.gray90};
    font-weight: 700;
  }
`;

export const DiscountImageWrapper = styled.div`
  position: relative;
  width: 328px;
  height: 200px;

  ${DESKTOP} {
    width: 425px;
    height: 260px;
  }
`;

export const PrestudyImageWrapper = styled.div`
  position: relative;
  width: 328px;
  height: 120px;

  ${DESKTOP} {
    width: 425px;
    height: 155px;
  }
`;

export const PrestudyDesc = styled.p`
  ${mBody2}
  color: ${grayScale.gray80};
  margin-top: 24px;

  br {
    display: none;
  }

  ${DESKTOP} {
    width: 425px;
    ${wBody2}
    color: ${grayScale.gray80};

    br {
      display: block;
    }
  }
`;
